import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable, Subscriber } from 'rxjs';
import 'rxjs/add/operator/map';
import { HttpClientService } from './../http-client/http-client.service';

@Injectable()
export class ImageService {

    constructor(
        private http: HttpClientService
    ) {        
    }    

    public add(productId: number, title: string, description: string, uri: string, isDefault: boolean) {
        const url = 'images/add';
        return this.http.post(url, {
            ProductId: productId,
            Title: title,
            Description: description,
            Uri: uri,
            IsDefault: isDefault
        }).map(response => response.json())
        .catch(this.handleError);
    }

    public delete(id: number) {
        const url = 'images/delete/' + id;
        return this.http.delete(url).map(response => response.json())
            .catch(this.handleError);
    }

    public upload(file: any, filename: string, type: string) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('filename', filename);
        formData.append('type', type);
        const url = 'images/upload';
        return this.http.post(url, formData).map(response => response.json())
            .catch(this.handleError);
    }

    public handleError(error: Response) {
        // console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }

}



// WEBPACK FOOTER //
// ./src/app/main/services/images/image.service.ts